declare global {
  interface Window {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    env: any;
  }
}

type EnvType = {
  REACT_APP_COLOR: string;
  REACT_APP_MAIN_TEXT: string;
  REACT_APP_LINK_URL: string;
  REACT_APP_LOGO_URL: string;
  NODE_ENV: string;
  REACT_APP_AVATAR_ENV: string;
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_NINJA_UI_URL: string;
  REACT_APP_NINJA_API_V2_URL: string;
  REACT_APP_E_ASSISTANT: string;
  REACT_APP_AVATAR_MATCHMAKER_SERVER: string;
  REACT_APP_AVATAR_FALLBACK: string;
  REACT_APP_CONV_ENDPOINT: string;
  REACT_APP_CONTACTS_ENDPOINT: string;
  REACT_APP_AVATARS_S3_BUCKET: string;
  REACT_APP_COMBUS_ENDPOINT: string;
  REACT_APP_COMBUS_WS_ENDPOINT: string;
  REACT_APP_DEBUG: boolean;
  REACT_APP_COGNITO_REGION: string;
  REACT_APP_COGNITO_OATH_DOMAIN: string;
  REACT_APP_COGNITO_USER_POOL_ID: string;
  REACT_APP_COGNITO_USER_POOL_CLIENT_ID: string;
  REACT_APP_GOOGLE_AUTHORIZATION_REDIRECT_URI: string;
  REACT_APP_GOOGLE_CLIENT_ID: string;
  REACT_APP_GOOGLE_API_KEY: string;
  REACT_APP_META_HUMAN_OFFLINE_RENDER_URL: string;
  REACT_APP_NINJA_TOKEN_API_URL: string;
  REACT_APP_S3_BUCKET: string;
  REACT_APP_META_HUMAN_BASE_URL: string;
  REACT_APP_GOOGLE_TAG_MANAGER_ID: string;
  REACT_APP_TEMPORARY_PASSWORD: string;
  REACT_APP_NINJA_WALLET_API_URL: string;
  REACT_APP_NINJA_WALLET_AMP_API_URL: string;
  REACT_APP_FACEBOOK_PIXEL_ID: string;
  REACT_APP_NINJA_CONTENT_API_URL: string;
  REACT_APP_STRIPE_PK: string;
  REACT_APP_BFF_URL: string;
  REACT_APP_PAYPAL_CLIENT_ID: string;
  REACT_APP_REQUEST_PROMPT_TEMPLATES: string;
  REACT_APP_SEARCH_API_URL: string;
  REACT_APP_FEEDBACK_API_URL: string;
  REACT_APP_ZENDESK_KEY: string;
  REACT_APP_KEYMASTER_API_URL: string;
  REACT_APP_EDITOR_API_URL: string;
  REACT_APP_MESSAGE_KEY: string;
  REACT_APP_SUPER_NINJA_URL: string;
  REACT_APP_POSTHOG_KEY: string;
  REACT_APP_POSTHOG_HOST: string;
  REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY: string;
  REACT_APP_COOKIE_DOMAIN: string;
};
export const env: EnvType = { ...process.env, ...window.env };
